export const formatAsMoney = (value: number | undefined) => {
  if (value == null) return "";
  return !isNaN(value)
    ? `${value
        .toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}\u00A0€`
    : "";
};

export const formatDate = (date: string | undefined) => {
  if (date == null || date === "") return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

export const formatDateTime = (date: string | undefined) => {
  if (date == null || date === "") return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");

  return `${day}.${month}.${year}  ${hours}:${minutes}:${seconds}`;
};

export const formatAsTimestamp = (date: string | undefined) => {
  if (date == null || date === "") return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const formatAsFloat = (value: string | number | undefined): number => {
  if (value == null || value === "") return 0;
  const stringValue = String(value);
  const normalized = stringValue.replace(/\./g, "").replace(",", ".");
  const result = parseFloat(normalized);
  return isNaN(result) ? 0 : result;
};

export const formatGermanNumber = (
  val: number | null | undefined,
  decimals: number
): string => {
  if (val === null || val === undefined || isNaN(Number(val))) return "";
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(val));
};

export const formatAsDecimal = (value: number | null | undefined) => {
  if (value == null) return "";
  return !isNaN(value)
    ? `${value
        .toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
    : "";
};
